import { Navigate } from "react-router-dom";

import { useKnowledgeBaseOutletContext } from "./useKnowledgeBaseOutletContext";

export const KnowledgeBaseFirstArticleRedirect = () => {
  const { basePath, tree } = useKnowledgeBaseOutletContext();

  const firstSection = tree[0];
  const firstDoc = firstSection?.docs?.[0];

  if (!firstSection || !firstDoc) {
    return null;
  }

  return (
    <Navigate
      to={`${basePath}/${firstSection.slug}/${firstDoc.slug}`}
      replace
    />
  );
};
